"use client";

import { useState } from "react";
import { isClientPaperMode } from "@/lib/wealth/paperClient";

/**
 * "Paper account: made-up data", in the corner of EVERY page while this device
 * is in Paper (lib/wealth/accountMode.ts), not only the Wealth tabs: the Daily
 * Flow's open-trade count, the Options recommendations' "already open" and
 * size, and a trade logged from the Options desk all read the paper journal
 * then, and a page that shows made-up figures has to say so.
 *
 * Mounted once by the shell (src/client/root.tsx), so it may read the shell's
 * own measurements (README principle 38): it sits above the phone's thumb tab
 * bar and inside the safe area (`--mpp-tabbar-h`, `--mpp-sab`, `--mpp-sal`,
 * app/globals.css), where a plain `bottom-3` would have put it under the bar
 * on an iPhone. It takes no clicks. The mode changes only with a reload, so it
 * is read once.
 */
export function PaperPill() {
  const [paper] = useState(isClientPaperMode);
  if (!paper) return null;
  return (
    <div
      role="status"
      className="pointer-events-none fixed z-[60] rounded-full bg-warn px-3 py-1 text-xs font-semibold text-on-warn shadow"
      style={{
        left: "calc(var(--mpp-sal, 0px) + 0.75rem)",
        bottom: "calc(var(--mpp-tabbar-h, 0px) + var(--mpp-sab, 0px) + 0.75rem)",
      }}
    >
      Paper account: made-up data
    </div>
  );
}
